const images = {
   ground: require('@/assets/images/default_images/ground_default.jpg'),
   default: require('@/assets/images/default_images/image_default.jpg'),
   user: require('@/assets/images/default_images/profile_blank.png'),
   map: require('@/assets/images/default_images/map_default.jpg'),
   pdf: require('@/assets/images/default_images/pdf.png'),
   stage: require('@/assets/images/default_images/stage_default.jpg'),
};

export default images;